import { useContext, useMemo, useEffect, useRef, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { ConfigContext } from 'contexts/ConfigContext'
import objectPath from 'object-path'
import Select from 'react-select'
import { Form, Col, Row, InputGroup, Image } from 'react-bootstrap'
import Label from './Label'
import InputPrepend from './InputPrepend'
import InputAppend from './InputAppend'
import { compareTwoValue, getCurrentUi, isNumber } from '../action/Data'
import { onUpdateCondition, searchCondition } from '../action/condition/Action'
import { hasRules } from 'designer/component/rules/Action'
import { getBaseURL } from 'utility/httpClient.util'
import FeatherIcon from 'feather-icons-react'
import { getOptionData } from '../action/Dropdown'
import { getConditionRuleJsonForm } from '../action/condition/FormComponentCondition.util'

const escapeRegExp = (value = '') => {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const CustomSelect = (props) => {
  let {
    uiKey,
    value,
    uischema,
    updateData,
    updateOtherValue,
    copyData = () => {},
    errors = {},
    label,
    data,
    config,
    fieldName,
    fieldKey,
  } = props
  let {
    isMulti,
    optionType = {},
    valueJoin,
    valueType,
    suffixText,
    elementWidth,
    controlId,
    placeholder = 'ยังไม่ระบุ',
    require,
    defaultValue,
    fieldDefaultName,
    fieldDefaultValue,
  } = uischema
  let uiSelectKey = uischema.key

  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    isWidgetUpdate,
  } = config

  const designContext = useContext(DesignContext)
  const {
    elementAction = {},
    jsonForm,
    setFieldFormData,
    setDatasourceValue,
    isUiChanged,
    setIsUiChanged,
    isResetData,
  } = designContext
  const configContext = useContext(ConfigContext)
  const { layoutType } = configContext.state
  const baseUrl = getBaseURL()
  let datasourceValue = objectPath.get(designContext, '@datasource') || {}

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uiSelectKey])
  let isEnable = objectPath.get(elementAction, ['isEnable', uiSelectKey])

  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  let hasRequire = objectPath.has(elementAction, ['isRequire', uiKey])
  let requireMessage = objectPath.get(elementAction, ['isRequire', uiKey])
  let showRequireMessage = hasRequire
    ? typeof requireMessage !== 'boolean'
    : require
  let isRequire = hasRequire || require
  let showRequire = value ? false : isRequire ? true : false

  let hasWarning = objectPath.has(elementAction, ['isWarning', uiKey])
  let warningMessage = objectPath.get(elementAction, ['isWarning', uiKey])
  let showWarningMessage = hasWarning
    ? typeof warningMessage !== 'boolean'
    : warningMessage

  let errorArray = objectPath.get(errors, uiKey) || []

  const list = objectPath.get(uischema, `${optionType}`) || {}
  const hasDynamicOption = objectPath.has(isUiChanged, [
    'tempDynamicOption',
    uiSelectKey,
    dynamicIndex,
  ])
  const dynamicOption = objectPath.get(isUiChanged, [
    'tempDynamicOption',
    uiSelectKey,
    dynamicIndex,
  ])
  const [isOnChange, setIsOnChange] = useState(false)
  const [selectValue, setSelectValue] = useState(null)
  const [otherParamUpdated, setOtherParamUpdated] = useState({})
  const isResetField = objectPath.get(isUiChanged, [
    'isResetField',
    uiSelectKey,
  ])
  const {
    optionLabel = 'label',
    optionValue = 'value',
    valueKey = {},
    labelColor,
  } = list
  const widgetName = config?.widgetName
  const isCreateDatasource =
    uischema?.isCreateDatasource || list?.isCreateDatasource
  const uiTitleValue = uischema?.titleValue
  const listTitleValue = list?.titleValue
  const titleValue =
    Array.isArray(uiTitleValue) && uiTitleValue.length > 0
      ? uiTitleValue
      : Array.isArray(listTitleValue) && listTitleValue.length > 0
      ? listTitleValue
      : []
  const hasTitleValue = titleValue.length > 0
  const valueKeyList = Object.keys(valueKey)
  const otherValues = uischema?.otherValues || list?.otherValues || {}
  const otherValuesList = Object.keys(otherValues)

  let { formComponent } = config
  let formComponentName = formComponent?.name
  let isFetchOption = formComponentName
    ? objectPath.get(isUiChanged, [
        formComponentName,
        uiSelectKey,
        'isFetchOption',
      ])
    : objectPath.get(isUiChanged, ['isFetchOption', uiSelectKey])
  const [options, setOptions] = useState([])
  const isFetchOptionOnMenuOpenRef = useRef(false)

  useEffect(async () => {
    if (isWidgetUpdate) {
      if (isUiChanged?.isSelected) {
        let options = await getOptionData({
          uischema,
          config,
          designContext,
          key: uiSelectKey,
          data,
          setOptions,
        })
        let selectValue = checkSelectValue(options, value)
        setSelectValue(selectValue)
        objectPath.set(isUiChanged, 'isSelected', false)
        setIsUiChanged(isUiChanged)
      }
    }
  }, [isWidgetUpdate])

  useEffect(async () => {
    let hasCondition = searchCondition(jsonForm, uiSelectKey, {
      actionKey: 'updateOption',
      returnActionKey: true,
    })
    if (hasCondition?.length > 0) {
      hasCondition.forEach(({ key }) => {
        let list = objectPath.get(elementAction, ['updateOption']) || []
        if (!list.includes(key)) {
          objectPath.push(elementAction, ['updateOption'], key)
        }
      })
    }
  }, [])

  useEffect(() => {
    getOptionData({
      uischema,
      config,
      designContext,
      key: uiSelectKey,
      data,
      propSelect: { isFetchOption },
      setOptions,
    })
  }, [isFetchOption])

  useEffect(() => {
    let conditionJsonForm = getConditionRuleJsonForm({
      jsonForm,
      isUiChanged,
      config,
    })
    let hasCondition = (conditionJsonForm.conditions || []).some(
      ({ isEnabled }) => isEnabled,
    )
    if (hasRules(conditionJsonForm) && !hasCondition) return
    let ruleUiKeys = [uiKey, uischema.key, uischema.name, fieldKey, fieldName]
      .filter((key) => key)
      .filter((key, index, list) => list.indexOf(key) === index)
    let status = { isOnChange, ruleUiKeys }

    if (value !== undefined) {
      objectPath.set(status, 'valueChange', value)
    }

    onUpdateCondition(props, designContext, uiKey, data, status)
  }, [value])

  useEffect(() => {
    if (isOnChange) {
      setIsOnChange(false)
    }
  }, [JSON.stringify(selectValue)])

  useEffect(() => {
    if (value !== undefined) {
      let selectValue = checkSelectValue(options, value)
      setSelectValue(selectValue)
      updateOtherValue(selectValue)
    } else {
      if (fieldDefaultName) {
        let foundDefault = options.find(
          (option) => {
            let optionDefaultValue = objectPath.get(option, fieldDefaultName)
            return compareTwoValue(
              'equalValue',
              optionDefaultValue,
              fieldDefaultValue,
              true,
            )
          },
        )
        setSelectValue(foundDefault)
        if (foundDefault) {
          updateData(foundDefault, true)
          updateOtherValue(foundDefault)
        }
      } else if (!isEmptyDefaultValue(defaultValue)) {
        let defaultSelectValue = checkSelectValue(options, defaultValue)
        setSelectValue(defaultSelectValue)
        if (defaultSelectValue) {
          updateData(defaultSelectValue, true)
          updateOtherValue(defaultSelectValue)
        }
      } else {
        setSelectValue(null)
      }
    }
  }, [value, JSON.stringify(options), isResetData, isResetField])

  let isOtherParamUpdate = objectPath.get(
    isUiChanged,
    `otherParamUpdated.${uiSelectKey}`,
  )

  useEffect(() => {
    let { value } = isOtherParamUpdate || {}
    if (value !== undefined) {
      if (isMulti) {
        if (!Array.isArray(value)) {
          value = [value]
        }
      } else {
        let selectValue = checkSelectValue(options, value)
        console.log('isOtherParamUpdate', isOtherParamUpdate)
        setSelectValue(selectValue)
        updateOtherValue(selectValue)
      }
    }
  }, [isOtherParamUpdate])

  const getDataValue = (value) => {
    if (value === true) {
      return 'true'
    }
    if (value === false) {
      return 'false'
    }
    if (value === null) {
      return 'null'
    }
    if (value === undefined) {
      return 'undefined'
    }
    if (isNumber(value)) {
      return Number(value)
    }
    return value
  }

  const getOptionValue = (option) => {
    if (optionValue) {
      if (objectPath.has(option, optionValue)) {
        return objectPath.get(option, optionValue)
      }
      return option || ''
    }
    return objectPath.get(option, 'value') || option || ''
  }

  const updateOtherParam = (selectValue = {}) => {
    valueKeyList.forEach((paramKey) => {
      let uiKey = objectPath.get(valueKey, paramKey)
      let value = objectPath.get(selectValue, paramKey)
      if (isDynamic) {
        let dynamicData = objectPath.get(jsonForm.formData, dynamicName)
        objectPath.set(dynamicData, `${dynamicIndex}.${uiKey}`, value)
        setFieldFormData(`${dynamicName}`, dynamicData)
        objectPath.set(otherParamUpdated, `${dynamicName}`, dynamicData)
      } else {
        let ui = getCurrentUi(uiKey, jsonForm.schema, jsonForm.uischema)
        if (ui.key === uiKey) {
          setFieldFormData(ui.name, value)
        }
        setFieldFormData(uiKey, value)
        objectPath.set(otherParamUpdated, `${uiKey}`, value)
      }
    })
    otherValuesList.forEach((paramKey) => {
      let { field } = objectPath.get(otherValues, paramKey) || {}
      let value = objectPath.get(selectValue, paramKey)
      let ui = getCurrentUi(field, jsonForm.schema, jsonForm.uischema)
      if (ui.key === field) {
        if (isDynamic) {
          let dynamicData = objectPath.get(jsonForm.formData, dynamicName)
          objectPath.set(dynamicData, `${dynamicIndex}.${ui.name}`, value)
          setFieldFormData(`${dynamicName}`, dynamicData)
          objectPath.set(otherParamUpdated, `${dynamicName}`, dynamicData)
        } else {
          setFieldFormData(ui.name, value)
          setFieldFormData(field, value)
          objectPath.set(otherParamUpdated, `${field}`, value)
        }
      }
    })
    checkOtherParamUpdated(otherParamUpdated)
  }

  const checkOtherParamUpdated = (otherParamUpdated) => {
    objectPath.set(isUiChanged, `otherParamUpdated`, otherParamUpdated)
    setIsUiChanged(isUiChanged)
    setOtherParamUpdated(otherParamUpdated)
  }

  const checkSelectValue = (options = [], value = '') => {
    let selectValue = null
    let selectOptionValue =
      value && typeof value === 'object' ? getOptionValue(value) : value
    if (isMulti) {
      if (valueType === 'string' && value) {
        if (!Array.isArray(value)) {
          value = value.split(valueJoin)
        }
      }
      if (Array.isArray(value)) {
        selectValue = value.map((value) => {
          let selectOptionValue =
            value && typeof value === 'object' ? getOptionValue(value) : value
          let newItem = options.find((option) => {
            let optionValue = getOptionValue(option)
            return (
              compareTwoValue(
                'equalValue',
                optionValue,
                selectOptionValue,
                true,
              ) ||
              compareTwoValue('equalValue', optionValue, value, true) ||
              compareTwoValue('equalValue', option, value, true)
            )
          })
          return newItem
        })
      }
    } else {
      selectValue = options.find((option) => {
        let optionValue = getOptionValue(option)
        return (
          compareTwoValue('equalValue', optionValue, selectOptionValue, true) ||
          compareTwoValue('equalValue', optionValue, value, true) ||
          compareTwoValue('equalValue', option, value, true)
        )
      })
    }
    updateOtherParam(selectValue)
    return selectValue
  }

  const isEmptyDefaultValue = (value) => {
    if (value === '' || value === undefined || value === null) return true
    if (Array.isArray(value) && value.length === 0) return true
    if (typeof value === 'object' && Object.keys(value).length === 0) return true

    return false
  }

  const fetchOptionOnMenuOpen = async () => {
    if (isReadOnly) return
    if (!['internal', 'external'].includes(optionType)) return
    if (isFetchOptionOnMenuOpenRef.current) return

    isFetchOptionOnMenuOpenRef.current = true
    try {
      await getOptionData({
        uischema,
        config,
        designContext,
        key: uiSelectKey,
        data,
        propSelect: {
          isFetchOption,
          forceFetch: Date.now(),
        },
        setOptions,
      })
    } catch (error) {
      console.error('There was an error!', error)
    } finally {
      isFetchOptionOnMenuOpenRef.current = false
    }
  }

  const createDatasource = (value = {}) => {
    if (!isCreateDatasource) return
    objectPath.set(datasourceValue, uiKey, value)
    setDatasourceValue(datasourceValue)
    setFieldFormData(`@${uiKey}`, value)
  }

  const createLabelFromTitleList = (data) => {
    let keyOptions = list.keyOptions
    let titleList = []
    let fontColor = ''
    let fontWeight = ''
    let isLockedSelect = false

    if (data?.isAll) {
      let label = objectPath.get(data, 'label')
      titleList = [
        {
          label,
          valueType: 'string',
        },
      ]
      return { titleList, fontColor, isLockedSelect }
    }

    titleValue.forEach(
      ({
        valueType = 'string',
        title,
        replaceValues,
        fontWeight: titleFontWeight,
      }) => {
        let itemFontColor = ''
        let itemFontWeight = titleFontWeight || ''
        let subTitle = []
        let subString = []
        title.forEach((title) => {
          let { __isNew__ } = title
          let labelValue = title.value
          let isLabelName = keyOptions.includes(labelValue)
          let titleKey = labelValue.startsWith('@')
            ? labelValue.replace('@', '')
            : labelValue
          let hasValue = objectPath.has(data, titleKey)
          if (hasValue) {
            labelValue = objectPath.get(data, titleKey)
            if (valueType === 'attachmentId') {
              let imageSrc = `${baseUrl}/media/attachment/thumbnail/${labelValue}`
              labelValue = imageSrc
            }
            if (replaceValues) {
              let foundReplace = replaceValues.find(({ value }) => {
                let aValue = getDataValue(labelValue)
                let bValue = getDataValue(value)
                return aValue === bValue
              })
              if (foundReplace) {
                let { replace } = foundReplace
                labelValue = replace
                itemFontColor = foundReplace.fontColor
                itemFontWeight = foundReplace.fontWeight || titleFontWeight
                isLockedSelect = foundReplace.isLockedSelect
              }
            }
          } else {
            if (isLabelName) {
              labelValue = ''
            }
            if (__isNew__ && labelValue.startsWith('@')) {
              labelValue = ''
            }
          }
          subTitle.push({
            label: labelValue,
            valueType,
            fontColor: itemFontColor,
            fontWeight: itemFontWeight,
          })
          subString.push(labelValue)
        })
        fontColor = itemFontColor || fontColor
        fontWeight = itemFontWeight || fontWeight
        if (valueType === 'attachmentId') {
          titleList = [...titleList, ...subTitle]
        } else {
          titleList.push({
            label: subString.join(''),
            valueType: 'string',
            fontColor: itemFontColor,
            fontWeight: itemFontWeight,
          })
        }
      },
    )
    return { titleList, fontColor, fontWeight, isLockedSelect }
  }

  const createLabelFromUseTitleValue = (data) => {
    if (data?.isAll) {
      return objectPath.get(data, 'label')
    }
    return objectPath.get(data, '@label')
  }

  const renderLabelListFromUseTitleValue = (data) => {
    let labelList = objectPath.get(data, '@labelList') || []
    if (!Array.isArray(labelList) || labelList.length === 0) return
    return labelList.map(
      ({ label, fontColor: itemFontColor, fontWeight: itemFontWeight }, index) => {
        if (!label) return null
        return (
          <span
            key={`select-label-list-${uiSelectKey}-${index + 1}`}
            style={{
              color: itemFontColor || undefined,
              fontWeight: itemFontWeight || 'normal',
            }}
          >
            {label}
          </span>
        )
      },
    )
  }

  const createLabelFromOptionLabel = (data) => {
    if (data?.isAll) {
      return objectPath.get(data, 'label')
    }
    if (Array.isArray(optionLabel)) {
      let labelString = []
      optionLabel.forEach(({ value, __isNew__ }) => {
        if (__isNew__) {
          labelString.push(value)
        } else {
          let label = objectPath.get(data, value)
          labelString.push(label)
        }
      })
      return labelString.join('')
    }
    return objectPath.get(data, optionLabel)
  }

  const SingleValue = ({ data, ...props }) => {
    const style = getOptionValueStyle(data)
    if (hasTitleValue) {
      let { titleList = [], fontColor } = createLabelFromTitleList(data)
      return (
        <div
          {...props.innerProps}
          className="custom-single-value"
          style={style}
        >
          {titleList.map(
            (
              {
                valueType,
                label,
                fontColor: itemFontColor,
                fontWeight: itemFontWeight,
              },
              index,
            ) => {
              if (valueType === 'string') {
                return (
                  <span
                    key={`select-single-value-${uiSelectKey}-${index + 1}`}
                    style={{
                      color: itemFontColor || fontColor || '#000',
                      fontWeight: itemFontWeight || 'normal',
                    }}
                  >
                    {label}
                  </span>
                )
              }
              if (valueType === 'attachmentId') {
                if (label) {
                  return (
                    <Image
                      key={`select-single-value-${uiSelectKey}-${index + 1}`}
                      id={`${uiSelectKey}-image-${index}`}
                      src={label}
                      style={{
                        width: '20px',
                        height: '20px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                      }}
                    />
                  )
                }
                return (
                  <div
                    key={`select-single-value-${uiSelectKey}-${index + 1}`}
                    className="bg-light"
                    style={{
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                    }}
                  ></div>
                )
              }
            },
          )}
        </div>
      )
    }
    let isUseTitleValue = objectPath.get(data, '@isUseTitleValue')
    let label = ''
    if (isUseTitleValue) {
      label =
        createLabelFromUseTitleValue(data) || createLabelFromOptionLabel(data)
    } else {
      label = createLabelFromOptionLabel(data)
    }
    let labelList = isUseTitleValue && renderLabelListFromUseTitleValue(data)

    return (
      <div {...props.innerProps} className="custom-single-value" style={style}>
        {labelList || <span>{label}</span>}
      </div>
    )
  }

  const deleteItems = (index) => {
    objectPath.del(selectValue, index)
    setSelectValue(selectValue)
    updateData(selectValue, true)
    copyData(selectValue)
    setSelectValue(selectValue)
    createDatasource(selectValue)
    updateOtherParam(selectValue)
  }

  const getOptionValueStyle = (data) => {
    let color
    let cursor = 'default'
    let isDisabled = objectPath.get(data, 'isDisabled')
    if (labelColor) {
      color = objectPath.get(data, labelColor) ?? '#000'
    }
    if (isDisabled) {
      color = 'grey'
      cursor = 'not-allowed'
    }
    let fontWeight = objectPath.get(data, '@fontWeight')
    return { color, cursor, fontWeight }
  }

  const renderOptionCheckbox = (isSelected) => {
    if (!isMulti) return null
    return (
      <input
        type="checkbox"
        checked={isSelected}
        readOnly
        tabIndex={-1}
      />
    )
  }

  const MultiValue = ({ data, index, ...props }) => {
    const style = getOptionValueStyle(data)
    let isUseTitleValue = objectPath.get(data, '@isUseTitleValue')
    let label = ''
    if (isUseTitleValue) {
      label =
        createLabelFromUseTitleValue(data) || createLabelFromOptionLabel(data)
    } else {
      label = createLabelFromOptionLabel(data)
    }
    let labelList = isUseTitleValue && renderLabelListFromUseTitleValue(data)

    return (
      <div {...props.innerProps} className="custom-single-value" style={style}>
        <span className="bg-light d-flex align-items-center p-1">
          {labelList || <span>{label}</span>}
          <FeatherIcon
            style={{ cursor: 'pointer' }}
            icon="trash"
            size="12"
            className="mr-1 ml-1 text-danger"
            onClick={() => deleteItems(index)}
          />
        </span>
      </div>
    )
  }

  const Option = ({ data, innerRef, innerProps, isFocused, isSelected }) => {
    const style = getOptionValueStyle(data)
    if (hasTitleValue) {
      let {
        titleList = [],
        fontColor,
        isLockedSelect,
      } = createLabelFromTitleList(data)

      return (
        <div
          ref={innerRef}
          {...innerProps}
          className={`custom-option ${
            !isLockedSelect && (isFocused || (isMulti && isSelected))
              ? 'focused'
              : ''
          } 
          ${isSelected ? 'selected' : ''} 
          ${isLockedSelect ? 'locked' : ''}`}
          style={style}
        >
          {renderOptionCheckbox(isSelected)}
          {titleList.map(
            (
              {
                valueType,
                label,
                fontColor: itemFontColor,
                fontWeight: itemFontWeight,
              },
              index,
            ) => {
              if (valueType === 'string') {
                return (
                  <span
                    key={`select-option-${uiSelectKey}-${index + 1}`}
                    style={{
                      color: itemFontColor || fontColor || '#000',
                      fontWeight: itemFontWeight || 'normal',
                    }}
                  >
                    {label}
                  </span>
                )
              }
              if (valueType === 'attachmentId') {
                if (label) {
                  return (
                    <Image
                      key={`select-option-${uiSelectKey}-${index + 1}`}
                      id={`${uiSelectKey}-image-${index}`}
                      src={label}
                      style={{
                        width: '20px',
                        height: '20px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                      }}
                    />
                  )
                }
                return (
                  <div
                    key={`select-option-${uiSelectKey}-${index + 1}`}
                    className="bg-light"
                    style={{
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                    }}
                  ></div>
                )
              }
            },
          )}
        </div>
      )
    }
    let isUseTitleValue = objectPath.get(data, '@isUseTitleValue')
    let label = ''
    if (isUseTitleValue) {
      label =
        createLabelFromUseTitleValue(data) || createLabelFromOptionLabel(data)
    } else {
      label = createLabelFromOptionLabel(data)
    }
    let labelList = isUseTitleValue && renderLabelListFromUseTitleValue(data)

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`custom-option ${
          isFocused || (isMulti && isSelected) ? 'focused' : ''
        } ${
          isSelected ? 'selected' : ''
        }`}
        style={style}
      >
        {renderOptionCheckbox(isSelected)}
        {labelList || <span>{label}</span>}
      </div>
    )
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: showRequire ? 'red' : 'lightgray',
    }),
  }

  const updateNormalSelect = (option) => {
    updateData(option, true)
    copyData(option)
    setSelectValue(option)
    createDatasource(option)
    updateOtherParam(option)
    setIsOnChange(true)
    objectPath.set(isUiChanged, 'isSelected', true)
  }

  return (
    <Form.Group className="mb-0" controlId={controlId}>
      <Row className="w-100 mx-0">
        <Label
          {...props}
          uischema={uischema}
          label={label}
          isRequire={isRequire}
          isEnable={!isReadOnly}
        />
        <Col sm={elementWidth} className="mt-1 p-0">
          <InputGroup
            style={{
              flexWrap: 'unset',
              background: isReadOnly ? '#e9ecef' : '',
            }}
          >
            <InputPrepend isReadOnly={isReadOnly} uischema={uischema} />
            <Select
              id={fieldKey}
              name={fieldName}
              styles={customStyles}
              menuPlacement={uischema.menuPlacement}
              inputId={uiSelectKey}
              isClearable
              isMulti={isMulti}
              closeMenuOnSelect={!isMulti}
              hideSelectedOptions={false}
              className="w-100"
              value={selectValue}
              options={hasDynamicOption ? dynamicOption : options}
              components={{ Option, SingleValue, MultiValue }}
              placeholder={placeholder}
              getOptionValue={(option) => getOptionValue(option)}
              onChange={(option) => updateNormalSelect(option)}
              onMenuOpen={fetchOptionOnMenuOpen}
              filterOption={(option, keyword) => {
                let { data } = option
                let labelTitle = createLabelFromUseTitleValue(data)
                let labelOption = createLabelFromOptionLabel(data)
                const label = labelTitle || labelOption || ''
                const value = objectPath.get(option.data, optionValue) || ''
                if (label && Array.isArray(label)) {
                  return label.includes(keyword)
                }
                if (value && Array.isArray(value)) {
                  return value.includes(keyword)
                }
                if (!keyword) {
                  keyword = ''
                }
                let regex = new RegExp(escapeRegExp(keyword), 'i')
                if (regex.test(label)) {
                  return regex.test(label)
                }
                return regex.test(value.toString())
              }}
              isDisabled={isReadOnly}
            />
            <InputAppend isReadOnly={isReadOnly} uischema={uischema} />
          </InputGroup>
        </Col>
        {suffixText && (
          <Col className="d-flex align-items-center mt-1 pr-0" sm="auto">
            <Form.Label className={`m-0 w-100`}>{suffixText}</Form.Label>
          </Col>
        )}
      </Row>
      <ul className="m-0 mt-2">
        {showRequire && showRequireMessage && requireMessage && (
          <li className="text-danger">{requireMessage}</li>
        )}
        {showWarningMessage && warningMessage && (
          <li className="text-danger">{warningMessage}</li>
        )}
        {errorArray.map((error, index) => (
          <li key={`error-${uiKey}-${index + 1}`} className="text-danger">
            {error}
          </li>
        ))}
      </ul>
    </Form.Group>
  )
}

export default CustomSelect
